import { Language } from "../languages";

export const historyTranslations: Record<Language, any> = {
  es: {
    title: "Borial Chronicles",
    subtitle: "Donde el Caos muerde, pero la esperanza perdura",
    sections: {
      "magic-era": {
        title: "🌌 La Era Mágica Original",
        era: "Época Antigua",
        content: `Hace siglos, el mundo estaba impregnado de energía mística. La magia fluía libremente a través de la tierra, los mares y el cielo. Grandes civilizaciones construyeron maravillas arquitectónicas utilizando hechizos de teletransportación, comunicación mental y manipulación elemental. Los dioses caminaban entre los mortales, y las criaturas míticas habitaban en bosques encantados y montañas celestiales. La humanidad vivía en armonía con las fuerzas sobrenaturales, respetando el delicado equilibrio del universo.`,
      },
      "magic-abuse": {
        title: "🔥 El Abuso y la Caída",
        era: "Gran Caída",
        content: `La ambición humana no conoció límites. Comenzaron a surgir imperios que explotaban la magia sin consideración. Extraían energía mística de fuentes sagradas, contaminando la tierra con residuos arcanos. Hechiceros arrogantes intentaron dominar la realidad misma, abriendo portales a dimensiones prohibidas. El abuso sistemático causó que la magia se volviera inestable e impredecible. Los primeros signos del colapso aparecieron: tormentas mágicas, criaturas corrompidas y fenómenos sobrenaturales destructivos.`,
      },
      collapse: {
        title: "💥 El Gran Colapso",
        era: "Gran Caída",
        content: `El punto de ruptura llegó con el "Evento del Silencio". La magia no desapareció por accidente; al ver el mundo al borde de la aniquilación, un grupo de sabios antiguos se sacrificó para crear un sello dimensional masivo. Tomaron toda la energía mágica inestable del planeta y la encerraron en una bóveda fuera de nuestra realidad. La humanidad se encontró de repente sin las herramientas que habían sostenido su civilización durante milenios. Fue una catástrofe global que sumió al mundo en una edad oscura, sobreviviendo solo aquellos con conocimientos tecnológicos básicos.`,
      },
      "technological-era": {
        title: "🔧 La Era Tecnológica",
        era: "Renacimiento",
        content: `Durante los siguientes 5000 años, la humanidad se reconstruyó basándose únicamente en la tecnología y la ciencia. Descubrieron la electricidad, desarrollaron motores de combustión y crearon redes de comunicación global. Ciudades de acero y concreto se alzaron donde antes habían existido torres de cristal mágico. La magia se convirtió en mito y leyenda, algo que solo existía en cuentos para niños. La sociedad prosperó, pero el mundo se volvió gris, mecánico y olvidó por completo el peligro que yacía bajo el sello.`,
      },
      "reality-crack": {
        title: "🌀 La Grieta de la Realidad",
        era: "Evento Actual",
        content: `En el año 2077, científicos que investigaban fuentes de energía alternativas perforaron accidentalmente la antigua barrera dimensional. Esta fisura, conocida como "El Desgarro", no abrió una puerta a un mundo nuevo, sino que rompió la bóveda de contención de sus ancestros. La energía que estalló era la magia de la antigüedad, pero tras milenios de encierro y presión, se había vuelto radiactiva, salvaje y vengativa: el Caos Residual. En cuestión de días, las leyes de la física colapsaron.`,
      },
      "residual-chaos": {
        title: "🌪️ El Caos Residual",
        era: "Evento Actual",
        content: `El Caos Residual afectó todo lo que tocó. Algunas personas murieron instantáneamente, incapaces de soportar la energía. Otras se convirtieron en "Marcados", humanos con acceso a poderes caóticos pero condenados a una lucha interna constante contra la locura. Un tercer grupo se transformó completamente en criaturas grotescas, perdidas para siempre en su propia corrupción. Las ciudades modernas cayeron cuando la tecnología falló masivamente en las zonas de alta concentración de Caos.`,
      },
      "new-world": {
        title: "🏙️ El Mundo Actual",
        era: "Presente",
        content: `Ahora, 20 años después del Desgarro, el mundo es un lugar fracturado. Ciudades en ruinas coexisten con bolsillos de realidad estable. Ya no existen visiones absolutas del bien o el mal; los sobrevivientes se han dividido en complejas facciones que negocian, pelean y sobreviven con sus propias agendas morales. Tú eres uno de los Marcados, caminando por la delgada línea entre el poder y la locura, forjando tu propio destino en las crónicas de este mundo transformado.`,
      },
      factions: {
        title: "🏘️ Grupos y Comunidades",
        era: "Presente",
        content: `En este mundo fracturado, las personas se han agrupado en comunidades basadas en intereses, habilidades y necesidades de supervivencia.`,
      },
      sages: {
        title: "El Refugio de los Sabios",
        content: `Un colectivo de eruditos, magos y científicos dedicados a estudiar el Caos Residual y encontrar formas de controlarlo o revertir sus efectos. Operan desde una ciudad oculta, protegida por barreras tanto tecnológicas como mágicas.`,
      },
      marked: {
        title: "La Hermandad de los Marcados",
        content: `Individuos afectados por el Caos Residual que aun mantienen su humanidad pero luchan contra la locura interna. Forman comunidades para apoyarse mutuamente y compartir conocimientos sobre cómo manejar sus poderes.`,
      },
      guardians: {
        title: "Los Guardianes Urbanos",
        content: `Milicias locales que protegen los asentamientos estables. No son héroes ni villanos, simplemente vecinos armados que defienden lo que queda de sus comunidades.`,
      },
      market: {
        title: "El Mercado Flotante",
        content: `Comerciantes nómadas que viajan entre zonas estables, intercambiando recursos, información y tecnología adaptada. Su lema: "Todo tiene un precio, excepto la verdad".`,
      },
      weavers: {
        title: "El Círculo de las Tejedoras",
        content: `Personas que han descubierto cómo manipular las fibras de la realidad. Crean artefactos que temporalmente estabilizan zonas de alto Caos, permitiendo la recuperación de recursos.`,
      },
      occultists: {
        title: "Los Ocultistas",
        content: `Grupos secretos que estudian rituales ancestrales, creyendo que la respuesta no está en combatir el Caos sino en entender sus patrones cíclicos.`,
      },
      reclaimers: {
        title: "Los Recolectores",
        content: `Expedicionarios que se aventuran en las zonas devastadas para recuperar tecnología, recursos y, ocasionalmente, sobrevivientes. Viven al día y confían en sus instintos.`,
      },
      allies: {
        title: "Los Solidarios",
        content: `Una red descentralizada que ofrece refugio, comida y atención médica sin preguntar por el pasado o las habilidades de nadie. Creen en la compasión como último bastión de humanidad.`,
      },
      "your-history": {
        title: "Tu historia comienza aquí...",
      },
      "the-legend": {
        title: "La leyenda está en tus manos. ¿Qué camino elegirás?",
      },
    },
  },
  en: {
    title: "Borial Chronicles",
    subtitle: "Where Chaos bites, but hope endures",
    sections: {
      "magic-era": {
        title: "🌌 The Original Magic Era",
        era: "Ancient Times",
        content: `Centuries ago, the world was steeped in mystical energy. Magic flowed freely through the land, the seas, and the sky. Great civilizations built architectural wonders using spells for teleportation, mental communication, and elemental manipulation. Gods walked among mortals, and mythical creatures dwelled within enchanted forests and celestial mountains. Humanity lived in harmony with the supernatural forces, honoring the delicate balance of the universe.`,
      },
      "magic-abuse": {
        title: "🔥 The Abuse and Fall",
        era: "Great Collapse",
        content: `Human ambition knew no bounds. Empires began to emerge that exploited magic without regard. They extracted mystical energy from sacred sources, polluting the land with arcane waste. Arrogant sorcerers attempted to dominate reality itself, opening portals to forbidden dimensions. Systematic abuse caused magic to become unstable and unpredictable. The first signs of collapse appeared: magical storms, corrupted creatures, and destructive supernatural phenomena.`,
      },
      collapse: {
        title: "💥 The Great Collapse",
        era: "Great Collapse",
        content: `The breaking point came with the "Silence Event." Magic didn't just vanish by accident; seeing the world on the brink of annihilation, a group of ancient sages sacrificed themselves to create a massive dimensional seal. They gathered all the unstable magical energy on the planet and locked it in a vault outside our reality. Humanity suddenly found itself without the tools that had sustained its civilization for millennia. It was a global catastrophe that plunged the world into a dark age, survived only by those with basic technological knowledge.`,
      },
      "technological-era": {
        title: "🔧 The Technological Era",
        era: "Renaissance",
        content: `For the next 5000 years, humanity rebuilt itself based solely on technology and science. They rediscovered electricity, developed combustion engines, and created global communication networks. Steel and concrete cities rose where once there had been towers of magical crystal. Magic became myth and legend, something that only existed in children's stories. Society thrived, but the world became gray, mechanical, and completely forgot the danger that lay beneath the seal.`,
      },
      "reality-crack": {
        title: "🌀 The Crack of Reality",
        era: "Current Event",
        content: `In 2077, scientists investigating alternative energy sources accidentally pierced the ancient dimensional barrier. This fissure, known as "The Tear," did not open a door to a new world; it shattered the containment vault of their ancestors. The energy that erupted was the magic of antiquity, but after millennia of confinement and pressure, it had become radioactive, wild, and vengeful: Residual Chaos. Within days, the laws of physics collapsed.`,
      },
      "residual-chaos": {
        title: "🌪️ The Residual Chaos",
        era: "Current Event",
        content: `Residual Chaos affected everything it touched. Some people died instantly, unable to endure the energy. Others became the "Marked"—humans with access to chaotic powers but doomed to a constant internal struggle against madness. A third group was completely transformed into grotesque creatures, forever lost to their own corruption. Modern cities fell as technology failed massively in areas of high Chaos concentration.`,
      },
      "new-world": {
        title: "🏙️ The New World",
        era: "Present",
        content: `Now, 20 years after the Tear, the world is a fractured place. Ruined cities coexist with pockets of stable reality. Absolute visions of good and evil no longer exist; survivors have divided into complex factions that negotiate, fight, and survive with their own moral agendas. You are one of the Marked, walking the fine line between power and madness, forging your own destiny in the chronicles of this transformed world.`,
      },
      factions: {
        title: "🏘️ Groups and Communities",
        era: "Present",
        content: `In this fractured world, people have grouped together into communities based on interests, skills, and survival needs.`,
      },
      sages: {
        title: "The Sages Refuge",
        content: `A collective of scholars, mages, and scientists dedicated to studying the Residual Chaos and finding ways to control it or reverse its effects. They operate from a hidden city, protected by both technological and magical barriers.`,
      },
      marked: {
        title: "The Marked Brotherhood",
        content: `A support network for those affected by the Chaos who have retained their humanity. They share techniques for controlling their abilities and protect each other from persecution.`,
      },
      guardians: {
        title: "The Urban Guardians",
        content: `Local militias that protect stable settlements. They are neither heroes nor villains, simply armed neighbors defending what remains of their communities.`,
      },
      market: {
        title: "The Floating Market",
        content: `Nomadic merchants who travel between stable zones, trading resources, information, and adapted technology. Their motto: "Everything has a price, except the truth."`,
      },
      weavers: {
        title: "The Weavers Circle",
        content: `Individuals who have discovered how to manipulate the fabric of reality. They create artifacts that temporarily stabilize high-Chaos zones, allowing for resource recovery.`,
      },
      occultists: {
        title: "The Occultists",
        content: `Secretive groups that study ancient rituals, believing the answer lies not in fighting the Chaos, but in understanding its cyclical patterns.`,
      },
      reclaimers: {
        title: "The Reclaimers",
        content: `Expeditioners who venture into the devastated zones to recover technology, resources, and occasionally, survivors. They live day-to-day and trust their instincts.`,
      },
      allies: {
        title: "The Solidarity Network",
        content: `A decentralized network that offers shelter, food, and medical care without asking about one's past or abilities. They believe compassion is the last bastion of humanity.`,
      },
      "your-history": {
        title: "Your history begins here...",
      },
      "the-legend": {
        title: "The legend is in your hands. What path will you choose?",
      },
    },
  },
};
